




































































































































import { Component, Model, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { ApptDetailedReportFilter } from "@/store/modules/types";
import CreatedDateFilter from "@/components/report/filters/CreatedDate.vue";
import ApptScheduleDate from "@/components/report/filters/ApptScheduleDate.vue";


@Component({
  computed: {...mapState("schedule", ["insurers","calendars"]),
     apptDateFilterOn: function () {
      return this.$store.state.schedule.filter.apptDate.from !=null || this.$store.state.schedule.filter.apptDate.to != null? true:false;
    }
  },
  components:{
    CreatedDateFilter,
    ApptScheduleDate
  }
})
export default class ApptDetailedSearch extends Vue {
  @Model("change") readonly filter!: ApptDetailedReportFilter;
  showApptDateFilter = false;
  lastShownFilter!: string;
  showCreatedDateFilter = false;
  filterDate!: string;
  showHideFilter(filter: string) {
    if (this.lastShownFilter && this.lastShownFilter !== filter) {
      this.showHideFilter(this.lastShownFilter);
    }
    let show = false;
    switch (filter) {
      case "CREATED_DATE":
        show = !this.showCreatedDateFilter;
        this.showCreatedDateFilter = show;
        break;
      case "APPT_DATE":
        show = !this.showApptDateFilter;
        this.showApptDateFilter = show;
        break;
    }
    this.lastShownFilter = show ? filter : "";
  }
  filters = [{id: false, name: 'Filter by Appt'},{id: true, name: 'Filter By Record'}];
  filterGaps = [{id: '', name: 'All'},{id: '0', name: 'Filter With no gap'},{id: '1', name: 'Filter With gap'}];
  originOptions = [{id: '',name:'All Origin'},{id: 'WAITINGMED', name: 'WaitingMed'},{id: 'KIOSK', name: 'Kiosk'}, {id: 'ONLINE', name: 'On Line'},{id: 'WMAPI',name: 'EMR vendor'}];
}
